import React from 'react';
import { ReservableQuestionField } from '../../../../../../../shared/types/reservable';
import { keyFromLabel } from '../../../../../../../shared/lib/utils';
import FieldFillerItem from './FieldFillerItem';

interface FieldFillerCardProps {
  title: string;
  fields: ReservableQuestionField[];
  values: Record<string, string>;
  onChangeField: (field: ReservableQuestionField, value: string) => void;
}

export default function FieldFillerCard(props: FieldFillerCardProps) {
  const { title, fields, values, onChangeField } = props;

  return (
    <div className="rounded-lg border border-border p-6 grid grid-cols-1 gap-8">
      <div className="flex items-center">
        <div className="font-bold text-lg text-accent">{title}</div>
      </div>
      <div className="grid grid-cols-1 gap-4">
        {fields.length === 0 ? (
          <div className="text-sm text-muted">
            All done! No additional information needed for this ticket.
          </div>
        ) : (
          fields.map(field => {
            const value = values[keyFromLabel(field.label)] || '';

            return (
              <FieldFillerItem
                key={field._id}
                field={field}
                value={value}
                onChange={newValue => onChangeField(field, newValue)}
              />
            );
          })
        )}
      </div>
    </div>
  );
}
